class CurrencyFormat {
  static calculateFormat(amount) {
    if (Intl && Intl.NumberFormat && window.PageInformations) {
      var charm_lang = window.PageInformations.language;
      if (window.PageInformations.language.indexOf("en") !== -1)
        charm_lang = "en";
      if (window.PageInformations.language.indexOf("zh") !== -1)
        charm_lang = "zh";

      return Intl.NumberFormat(charm_lang, {
        style: "currency",
        currency: window.PageInformations.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    } else {
      return amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    }
  }
}

export default CurrencyFormat;
